import { ModalManager } from "@iunctim/component-modal/Resources/Public/Scripts/components/ModalManager.js";
import { DisplayPolicy } from "./components/DisplayPolicy.js";

ModalManager.use();
DisplayPolicy.use();
